"use strict";

var _defineProperty = require("/codebuild/output/src1770955296/src/omg-revamp/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/codebuild/output/src1770955296/src/omg-revamp/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/codebuild/output/src1770955296/src/omg-revamp/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/codebuild/output/src1770955296/src/omg-revamp/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/es.promise.finally.js");

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function interceptPromise(p, handleResponse, handleError) {
  p.then(function (resp) {
    handleResponse(resp);
    return resp;
  }).catch(function (err) {
    handleError(err);
    throw err;
  }).finally(function () {});
  return p;
}

var createQoreContext = function createQoreContext(client) {
  var context = react_1.default.createContext({
    client: client
  });

  var useCurrentUser = function useCurrentUser() {
    var qoreClient = useClient();

    var _react_1$default$useS = react_1.default.useState("idle"),
        _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
        status = _react_1$default$useS2[0],
        setStatus = _react_1$default$useS2[1];

    var _react_1$default$useS3 = react_1.default.useState(null),
        _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
        error = _react_1$default$useS4[0],
        setError = _react_1$default$useS4[1];

    var _react_1$default$useS5 = react_1.default.useState(null),
        _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
        user = _react_1$default$useS6[0],
        setUser = _react_1$default$useS6[1];

    react_1.default.useEffect(function () {
      (function () {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _user;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setStatus("loading");
                  _context.prev = 1;
                  _context.next = 4;
                  return qoreClient.currentUser();

                case 4:
                  _user = _context.sent;
                  setUser(_user);
                  setStatus("success");
                  _context.next = 14;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](1);
                  setUser(null);
                  setError(_context.t0);
                  setStatus("error");

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 9]]);
        }));
      })();
    }, []);
    return {
      status: status,
      error: error,
      user: user
    };
  };

  function createViewHooks(currentViewId) {
    var _this = this;

    var rowActions = {};
    return {
      useListRow: function useListRow() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var qoreClient = useClient();

        var _react_1$default$useS7 = react_1.default.useState([]),
            _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
            data = _react_1$default$useS8[0],
            setData = _react_1$default$useS8[1];

        var _react_1$default$useS9 = react_1.default.useState("idle"),
            _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
            status = _react_1$default$useS10[0],
            setStatus = _react_1$default$useS10[1];

        var _react_1$default$useS11 = react_1.default.useState(null),
            _react_1$default$useS12 = _slicedToArray(_react_1$default$useS11, 2),
            error = _react_1$default$useS12[0],
            setError = _react_1$default$useS12[1];

        var stream = react_1.default.useMemo(function () {
          return qoreClient.view(currentViewId).readRows(opts, config);
        }, [].concat(_toConsumableArray(Object.entries(opts).flat()), _toConsumableArray(Object.entries(config).flat()), [currentViewId]));
        react_1.default.useEffect(function () {
          setStatus("loading");
          var subscription = stream.subscribe(function (_ref) {
            var error = _ref.error,
                data = _ref.data;

            if (error) {
              setError(error);
              setStatus("error");
            }

            if (data) {
              setError(null);
              setData(data.nodes);
              setStatus("success");
            }
          });
          return function () {
            subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
          };
        }, [stream]);
        var revalidate = react_1.default.useCallback(function (config) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var result;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return stream.revalidate(config);

                  case 2:
                    result = _context2.sent;
                    return _context2.abrupt("return", result);

                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
        }, [stream.revalidate]);
        return {
          data: data,
          error: error,
          status: status,
          revalidate: revalidate,
          fetchMore: stream.fetchMore
        };
      },
      useGetRow: function useGetRow(rowId) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var qoreClient = useClient();

        var _react_1$default$useS13 = react_1.default.useState(null),
            _react_1$default$useS14 = _slicedToArray(_react_1$default$useS13, 2),
            data = _react_1$default$useS14[0],
            setData = _react_1$default$useS14[1];

        var _react_1$default$useS15 = react_1.default.useState("idle"),
            _react_1$default$useS16 = _slicedToArray(_react_1$default$useS15, 2),
            status = _react_1$default$useS16[0],
            setStatus = _react_1$default$useS16[1];

        var _react_1$default$useS17 = react_1.default.useState(null),
            _react_1$default$useS18 = _slicedToArray(_react_1$default$useS17, 2),
            error = _react_1$default$useS18[0],
            setError = _react_1$default$useS18[1];

        var stream = react_1.default.useMemo(function () {
          return qoreClient.view(currentViewId).readRow(rowId, config);
        }, [rowId].concat(_toConsumableArray(Object.entries(config).flat()), [currentViewId]));
        react_1.default.useEffect(function () {
          setStatus("loading");
          var subscription = stream.subscribe(function (_ref2) {
            var data = _ref2.data,
                error = _ref2.error;

            if (error) {
              setError(error);
              setStatus("error");
            }

            if (data) {
              setData(data);
              setError(null);
              setStatus("success");
            }
          });
          return function () {
            subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
          };
        }, [stream]);
        var revalidate = react_1.default.useCallback(function (config) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var result;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return stream.revalidate(config);

                  case 2:
                    result = _context3.sent;
                    return _context3.abrupt("return", result);

                  case 4:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
        }, [stream.revalidate]);
        return {
          data: data,
          error: error,
          status: status,
          revalidate: revalidate
        };
      },
      useInsertRow: function useInsertRow() {
        var qoreClient = useClient();

        var _react_1$default$useS19 = react_1.default.useState("idle"),
            _react_1$default$useS20 = _slicedToArray(_react_1$default$useS19, 2),
            status = _react_1$default$useS20[0],
            setStatus = _react_1$default$useS20[1];

        var _react_1$default$useS21 = react_1.default.useState(null),
            _react_1$default$useS22 = _slicedToArray(_react_1$default$useS21, 2),
            error = _react_1$default$useS22[0],
            setError = _react_1$default$useS22[1];

        var insertRow = react_1.default.useCallback(function (data) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            var result;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.prev = 0;
                    setStatus("loading");
                    _context4.next = 4;
                    return qoreClient.view(currentViewId).insertRow(data);

                  case 4:
                    result = _context4.sent;
                    setError(null);
                    setStatus("success");
                    return _context4.abrupt("return", result);

                  case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4["catch"](0);
                    setStatus("error");
                    setError(_context4.t0);

                  case 14:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[0, 10]]);
          }));
        }, [currentViewId]);
        return {
          insertRow: insertRow,
          status: status,
          error: error
        };
      },
      useUpdateRow: function useUpdateRow() {
        var qoreClient = useClient();

        var _react_1$default$useS23 = react_1.default.useState("idle"),
            _react_1$default$useS24 = _slicedToArray(_react_1$default$useS23, 2),
            status = _react_1$default$useS24[0],
            setStatus = _react_1$default$useS24[1];

        var _react_1$default$useS25 = react_1.default.useState(null),
            _react_1$default$useS26 = _slicedToArray(_react_1$default$useS25, 2),
            error = _react_1$default$useS26[0],
            setError = _react_1$default$useS26[1];

        var updateRow = react_1.default.useCallback(function (rowId, data) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
            var result;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.prev = 0;
                    setStatus("loading");
                    _context5.next = 4;
                    return qoreClient.view(currentViewId).updateRow(rowId, data);

                  case 4:
                    result = _context5.sent;
                    setError(null);
                    setStatus("success");
                    return _context5.abrupt("return", result);

                  case 10:
                    _context5.prev = 10;
                    _context5.t0 = _context5["catch"](0);
                    setStatus("error");
                    setError(_context5.t0);

                  case 14:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, null, [[0, 10]]);
          }));
        }, [currentViewId]);
        return {
          updateRow: updateRow,
          status: status,
          error: error
        };
      },
      useDeleteRow: function useDeleteRow() {
        var qoreClient = useClient();

        var _react_1$default$useS27 = react_1.default.useState("idle"),
            _react_1$default$useS28 = _slicedToArray(_react_1$default$useS27, 2),
            status = _react_1$default$useS28[0],
            setStatus = _react_1$default$useS28[1];

        var _react_1$default$useS29 = react_1.default.useState(null),
            _react_1$default$useS30 = _slicedToArray(_react_1$default$useS29, 2),
            error = _react_1$default$useS30[0],
            setError = _react_1$default$useS30[1];

        var deleteRow = react_1.default.useCallback(function (rowId) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            var result;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.prev = 0;
                    setStatus("loading");
                    _context6.next = 4;
                    return qoreClient.view(currentViewId).deleteRow(rowId);

                  case 4:
                    result = _context6.sent;
                    setError(null);
                    setStatus("success");
                    return _context6.abrupt("return", result);

                  case 10:
                    _context6.prev = 10;
                    _context6.t0 = _context6["catch"](0);
                    setStatus("error");
                    setError(_context6.t0);

                  case 14:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, null, [[0, 10]]);
          }));
        }, [currentViewId]);
        return {
          deleteRow: deleteRow,
          status: status,
          error: error
        };
      },
      useActions: function useActions(rowId) {
        var qoreClient = useClient();
        var qoreClientRowActions = qoreClient.view(currentViewId).actions;

        var _react_1$default$useS31 = react_1.default.useState(Object.keys(qoreClientRowActions).reduce(function (prev, curr) {
          return Object.assign(Object.assign({}, prev), _defineProperty({}, curr, "idle"));
        }, {})),
            _react_1$default$useS32 = _slicedToArray(_react_1$default$useS31, 2),
            statuses = _react_1$default$useS32[0],
            setStatuses = _react_1$default$useS32[1];

        var _react_1$default$useS33 = react_1.default.useState(Object.keys(qoreClientRowActions).reduce(function (prev, curr) {
          return Object.assign(Object.assign({}, prev), _defineProperty({}, curr, null));
        }, {})),
            _react_1$default$useS34 = _slicedToArray(_react_1$default$useS33, 2),
            errors = _react_1$default$useS34[0],
            setErrors = _react_1$default$useS34[1];

        var createAction = react_1.default.useCallback(function (actionId) {
          return {
            trigger: function trigger(input) {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                var result;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.prev = 0;
                        setStatuses(Object.assign(Object.assign({}, statuses), _defineProperty({}, actionId, "loading")));
                        _context7.next = 4;
                        return qoreClient.view(currentViewId).action(actionId).trigger(rowId, input);

                      case 4:
                        result = _context7.sent;
                        setStatuses(Object.assign(Object.assign({}, statuses), _defineProperty({}, actionId, "success")));
                        setErrors(Object.assign(Object.assign({}, errors), _defineProperty({}, actionId, null)));
                        return _context7.abrupt("return", result);

                      case 10:
                        _context7.prev = 10;
                        _context7.t0 = _context7["catch"](0);
                        setStatuses(Object.assign(Object.assign({}, statuses), _defineProperty({}, actionId, "error")));
                        setErrors(Object.assign(Object.assign({}, errors), _defineProperty({}, actionId, _context7.t0)));
                        return _context7.abrupt("return", false);

                      case 15:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[0, 10]]);
              }));
            }
          };
        }, [rowId, currentViewId]);
        var action = react_1.default.useCallback(function (actionId) {
          if (!rowActions[actionId]) {
            rowActions[actionId] = createAction(actionId);
          }

          return rowActions[actionId];
        }, [createAction]);
        react_1.default.useMemo(function () {
          for (var _i = 0, _Object$keys = Object.keys(qoreClient.view(currentViewId).actions); _i < _Object$keys.length; _i++) {
            var actionId = _Object$keys[_i];
            rowActions[actionId] = createAction(actionId);
          }
        }, [createAction, currentViewId]);
        return {
          statuses: statuses,
          errors: errors,
          rowActions: rowActions,
          action: action
        };
      },
      useRelation: function useRelation(rowId) {
        var qoreClient = useClient();

        var _react_1$default$useS35 = react_1.default.useState({
          addRelation: "idle",
          removeRelation: "idle"
        }),
            _react_1$default$useS36 = _slicedToArray(_react_1$default$useS35, 2),
            statuses = _react_1$default$useS36[0],
            setStatuses = _react_1$default$useS36[1];

        var _react_1$default$useS37 = react_1.default.useState({
          removeRelation: null,
          addRelation: null
        }),
            _react_1$default$useS38 = _slicedToArray(_react_1$default$useS37, 2),
            errors = _react_1$default$useS38[0],
            setErrors = _react_1$default$useS38[1];

        var addRelation = react_1.default.useCallback(function (relations) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    setStatuses(function (statuses) {
                      return Object.assign(Object.assign({}, statuses), {
                        addRelation: "loading"
                      });
                    });
                    _context8.prev = 1;
                    _context8.next = 4;
                    return qoreClient.view(currentViewId).addRelation(rowId, relations);

                  case 4:
                    setStatuses(function (statuses) {
                      return Object.assign(Object.assign({}, statuses), {
                        addRelation: "success"
                      });
                    });
                    setErrors(function (errors) {
                      return Object.assign(Object.assign({}, errors), {
                        addRelation: null
                      });
                    });
                    return _context8.abrupt("return", true);

                  case 9:
                    _context8.prev = 9;
                    _context8.t0 = _context8["catch"](1);
                    setStatuses(function (statuses) {
                      return Object.assign(Object.assign({}, statuses), {
                        addRelation: "error"
                      });
                    });
                    setErrors(function (errors) {
                      return Object.assign(Object.assign({}, errors), {
                        addRelation: _context8.t0
                      });
                    });
                    return _context8.abrupt("return", false);

                  case 14:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, null, [[1, 9]]);
          }));
        }, [currentViewId, rowId]);
        var removeRelation = react_1.default.useCallback(function (relations) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    setStatuses(function (statuses) {
                      return Object.assign(Object.assign({}, statuses), {
                        removeRelation: "loading"
                      });
                    });
                    _context9.prev = 1;
                    _context9.next = 4;
                    return qoreClient.view(currentViewId).removeRelation(rowId, relations);

                  case 4:
                    setStatuses(function (statuses) {
                      return Object.assign(Object.assign({}, statuses), {
                        removeRelation: "success"
                      });
                    });
                    setErrors(function (errors) {
                      return Object.assign(Object.assign({}, errors), {
                        removeRelation: null
                      });
                    });
                    return _context9.abrupt("return", true);

                  case 9:
                    _context9.prev = 9;
                    _context9.t0 = _context9["catch"](1);
                    setStatuses(function (statuses) {
                      return Object.assign(Object.assign({}, statuses), {
                        removeRelation: "error"
                      });
                    });
                    setErrors(function (errors) {
                      return Object.assign(Object.assign({}, errors), {
                        removeRelation: _context9.t0
                      });
                    });
                    return _context9.abrupt("return", false);

                  case 14:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, null, [[1, 9]]);
          }));
        }, [currentViewId, rowId]);
        return {
          statuses: statuses,
          errors: errors,
          addRelation: addRelation,
          removeRelation: removeRelation
        };
      },
      useForm: function useForm(formId) {
        var qoreClient = useClient();
        var form = qoreClient.view(currentViewId).form(formId);

        var _react_1$default$useS39 = react_1.default.useState("idle"),
            _react_1$default$useS40 = _slicedToArray(_react_1$default$useS39, 2),
            status = _react_1$default$useS40[0],
            setStatus = _react_1$default$useS40[1];

        var _react_1$default$useS41 = react_1.default.useState(null),
            _react_1$default$useS42 = _slicedToArray(_react_1$default$useS41, 2),
            error = _react_1$default$useS42[0],
            setError = _react_1$default$useS42[1];

        var send = react_1.default.useCallback(function (params) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
            var resp;
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.prev = 0;
                    setStatus("loading");
                    _context10.next = 4;
                    return form.sendForm(params);

                  case 4:
                    resp = _context10.sent;
                    setError(null);
                    setStatus("success");
                    return _context10.abrupt("return", resp);

                  case 10:
                    _context10.prev = 10;
                    _context10.t0 = _context10["catch"](0);
                    setStatus("error");
                    setError(_context10.t0);
                    throw _context10.t0;

                  case 15:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10, null, [[0, 10]]);
          }));
        }, []);
        return {
          send: send,
          error: error,
          status: status
        };
      }
    };
  }

  var useClient = function useClient() {
    var _react_1$default$useC = react_1.default.useContext(context),
        client = _react_1$default$useC.client;

    return client;
  };

  var views = new Proxy({}, {
    // @ts-ignore
    get: function get(views, currentViewId) {
      if (!views[currentViewId]) {
        views[currentViewId] = createViewHooks(currentViewId);
      }

      return views[currentViewId];
    }
  });

  function view(id) {
    if (!views[id]) {
      views[id] = createViewHooks(id);
    }

    return views[id];
  }

  return {
    views: views,
    view: view,
    client: client,
    context: context,
    useClient: useClient,
    useCurrentUser: useCurrentUser
  };
};

exports.default = createQoreContext;